// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GDVd","rootMobile":"styles_rootMobile__3lY7J"};